import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as TotalTeamsIcon } from "../../../../../assets/images/People/Groups/total-teams.svg";
import { ReactComponent as TotalAgentsIcon } from "../../../../../assets/images/People/Groups/total-agents.svg";
import { ReactComponent as TotalChatsIcon } from "../../../../../assets/images/People/Groups/total-chats.svg";
import { ReactComponent as TotalTicketsIcon } from "../../../../../assets/images/People/Groups/total-tickets.svg";

const containerSx = {
  width: 632,
  maxWidth: "100%",
  height: 96,
  borderRadius: "8px",
  border: "1px solid #E5E9EC",
  background: "#FFF",
  display: "flex",
  boxSizing: "border-box",
  mb: 3,
};

function StatCell({ icon: Icon, label, value, showDivider }) {
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        px: 2,
        boxSizing: "border-box",
        borderRight: showDivider ? "1px solid #E5E9EC" : "none",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          height: 24,
          mb: "7px",
        }}
      >
        <Icon style={{ width: 16, height: 16, flexShrink: 0, display: "block" }} />
        <Typography
          component="span"
          sx={{
            color: "#405261",
            fontFamily: "Inter",
            fontSize: 12,
            fontWeight: 400,
            lineHeight: "18px",
          }}
        >
          {label}
        </Typography>
      </Box>
      <Box
        sx={{
          height: 33,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          component="span"
          sx={{
            color: "#061522",
            fontFamily: "Inter",
            fontSize: 24,
            fontWeight: 500,
            lineHeight: 1,
          }}
        >
          {value.toLocaleString()}
        </Typography>
      </Box>
    </Box>
  );
}

export default function GroupDetailStatsRow({ stats }) {
  return (
    <Box sx={containerSx}>
      <StatCell icon={TotalTeamsIcon} label="Total Teams" value={stats.totalTeams} showDivider />
      <StatCell icon={TotalAgentsIcon} label="Total Agents" value={stats.totalAgents} showDivider />
      <StatCell icon={TotalChatsIcon} label="Total Chats" value={stats.totalChats} showDivider />
      <StatCell
        icon={TotalTicketsIcon}
        label="Total Tickets"
        value={stats.totalTickets}
        showDivider={false}
      />
    </Box>
  );
}
